import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RenaissancePage from "../pages/renaissance/page";
import ManyMonaPage from "../pages/many-mona/page";
import MmntoMoriPage from "../pages/mmnto-mori/page";
import BioPage from "../pages/bio/page";
import GalleryPage from "../pages/gallery/page";
import MarcusAureliusPage from "../pages/artist/marcus-aurelius/page";
import IsabellaRossiPage from "../pages/artist/isabella-rossi/page";
import CassiusVelPage from "../pages/artist/cassius-vel/page";
import SeraphinaDorPage from "../pages/artist/seraphina-dor/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
  },
  {
    path: "/renaissance",
    element: <RenaissancePage />,
  },
  {
    path: "/many-mona",
    element: <ManyMonaPage />,
  },
  {
    path: "/mmnto-mori",
    element: <MmntoMoriPage />,
  },
  {
    path: "/bio",
    element: <BioPage />,
  },
  {
    path: "/artist/marcus-aurelius",
    element: <MarcusAureliusPage />,
  },
  {
    path: "/artist/isabella-rossi",
    element: <IsabellaRossiPage />,
  },
  {
    path: "/artist/cassius-vel",
    element: <CassiusVelPage />,
  },
  {
    path: "/artist/seraphina-dor",
    element: <SeraphinaDorPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;